import '../App.css';
import '../style.css';
import '../font.css';
import '../workDetailPage/style_works.css';
import { ArticleMainImage } from './ArticleMainImage';
import { Thumbnail } from '../components/WorkThumbnail';
import { Divider } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

export function ArticleTitle(props: {
    title: string;
    description? : React.ReactNode ;
    category? : string;
    date? : string;
    showButton?: boolean;
    buttonLabel?: string;
    buttonHref?: string;
    thumbnail?:string;
    /** 영문 토글 시 노출되는 텍스트. 없으면 한국어 원문을 그대로 보여줌. */
    titleEn?: string;
    descriptionEn?: React.ReactNode;
    categoryEn?: string;
}) {
    const { language } = useLanguage();
    const isEn = language === 'en';
    const displayTitle = isEn && props.titleEn ? props.titleEn : props.title;
    const displayDescription =
      isEn && props.descriptionEn !== undefined ? props.descriptionEn : props.description;
    const displayCategory =
      isEn && props.categoryEn ? props.categoryEn : props.category;

    return (
        <div className='articleTitleSection'>
         <div className='articleTitleSectionGap'>
                {props.thumbnail && (
                    <ArticleMainImage image={props.thumbnail} />
                )}
                <div className='gap48'>
                    <div className='articleTitleSectionTitleGap'>
                        <div className='articlePageTitle'>{displayTitle}</div>
                        {displayDescription && (
                            <div className='articlePageDescription'>{displayDescription}</div>
                        )}
                    </div>
                    {(displayCategory || props.date) && (
                        <div className='articleTitleSectionTag'>
                            {displayCategory && <div className='articlePageCategory'>{displayCategory}</div>}
                            {displayCategory && props.date && '·'}
                            {props.date && <div className='articlePageDate'>{props.date}</div>}
                        </div>
                    )}
                </div>
                </div>
                <Divider className = 'divider2'/>
            <div>
        </div>
        </div>
    )
}
